module.exports = __webpack_public_path__ + "static/media/noun-reject-1890961-FFFFFF.8dd71e3c.svg";